import React from "react";
import ReactPlayer from "react-player/lazy";

const VideoPlayer = () => {
  return (
    <ReactPlayer
      url="https://terafac-website.s3.ap-south-1.amazonaws.com/videos/Terafac_Intro_Video.mp4"
      controls
      width="100%"
      height="100%"
    />
  );
};

export default VideoPlayer;
